<app-attachments-browser
  [isLoading]="(isLoading$ | async) ?? true"
  [attachmentsPath]="attachmentsPath$ | async"
  [canUpload]="(canUploadFiles$ | async) === true"
  [showBreadcrumbs]="true"
  [allowFolders]="true"
  [showStorageCard]="true"
  [isReadonly]="(canEditProject$ | async) === false"
  [storageUsage]="storageUsage$ | async"
  [breadcrumbs]="(breadcrumbs$ | async) ?? []"
  [folders]="(folders$ | async) ?? null"
  [files]="(files$ | async) ?? null"
  (uploadedFile)="onUploadFile($event)"
  (deletedUploadedFile)="onDeleteFile($event)"
  (reachedStorageLimit)="onReachedStorageLimit()"
  (breadcrumbSelected)="goToBreadcrumb($event)"
  (folderCreate)="createFolderInline($event)"
  (folderOpen)="onOpenFolder($event)"
  (folderRename)="onRenameFolder($event.name, $event.id)"
  (folderRemove)="deleteAttachment($event, true)"
  (fileRename)="renameFile($event.id, $event.name)"
  (fileRemove)="deleteAttachment($event)"
  (fileAction)="handleFileAction($event.file, $event.action)"
></app-attachments-browser>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>
